/**
 * Helper that pauses all audio players on a page, which will commenly be used
 * when starting a new Speaker.
 */
export function stopAllAudioPlayers(): void {
  document.querySelectorAll<HTMLAudioElement>("audio").forEach((element) => {
    element.pause();
  });
}
